var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGmail = function SvgGmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 64,
    fill: "#EDF8FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.924 86.651h9.607V63.32L33.807 53.027v29.507a4.116 4.116 0 0 0 4.117 4.117z",
    fill: "#A6BBC9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.469 86.651h9.607a4.116 4.116 0 0 0 4.117-4.117V53.027L80.47 63.32",
    fill: "#829DAE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.469 45.478V63.32l13.724-10.293v-5.49c0-5.091-5.812-7.994-9.881-4.94",
    fill: "#B2CAD9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.531 63.32V45.48L64 57.83l16.469-12.352V63.32L64 75.672",
    fill: "#91A9B8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.807 47.537v5.49L47.53 63.32V45.478l-3.843-2.882c-4.076-3.053-9.881-.15-9.881 4.941",
    fill: "#7E98A8"
  })));
};
export default SvgGmail;